import { useState } from 'react';
import Page from '../components/Page';
import Container from '../components/Container';
import Input from '../components/Input';
import Button from '../components/Button';
import Error from './_error';
import { toast } from 'react-toastify';
import { saveUser, useUser } from '@mm/common';
import Spinner from '../components/Spinner';
import { useApi } from '@mm/common';

export async function getStaticProps(context) {
  return {
    props: {},
  };
}

export default () => {
  const { data: user, isLoading } = useUser();

  if (isLoading)
    return (
      <Page title="Профил">
        <Spinner className="my-12" />
      </Page>
    );

  if (!user) {
    return <Error statusCode={404} />;
  }

  return <Account />;
};

function Account() {
  const api = useApi();
  const { data: user, mutate } = useUser();
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  // const [city, setCity] = useState(user.city);
  const [password, setPassword] = useState(undefined);
  const [password2, setPassword2] = useState(undefined);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<any>();

  return (
    <Page title="Профил">
      <Container className="max-w-screen-md">
        <h1 className="text-2xl font-bold mb-6">Профил</h1>
        <form
          onSubmit={async e => {
            e.preventDefault();
            setError(null);

            try {
              const newUser = {
                ...user,
                name,
                email,
                password,
              };
              await saveUser(api)(newUser);
              await mutate(newUser, { revalidate: false });
              toast('✓ Профилът беше запазен успешно.', {
                position: 'bottom-center',
              });
            } catch (e) {
              setError(e);
            }
          }}
        >
          <label className="block mb-2">
            <span className="font-medium text-sm mb-1 block">Име</span>
            <Input
              block
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Име Фамилия"
              name="name"
              required
              autoComplete="name"
            />
          </label>

          <label className="block">
            <span className="font-medium text-sm mb-1 block">Email</span>
            <Input
              block
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@domain.com"
              name="email"
              required
              autoComplete="email"
            />
          </label>

          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => setShowPassword(!showPassword)}
            className="my-2"
          >
            Смени Парола
          </Button>

          {showPassword && (
            <>
              <label className="relative block mb-2">
                <span className="font-medium text-sm mb-1 block">
                  Нова Парола
                </span>
                <Input
                  block
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                />
              </label>

              <label className="relative block">
                <span className="font-medium text-sm mb-1 block">
                  Повтори Парола
                </span>
                <Input
                  block
                  onChange={e => setPassword2(e.target.value)}
                  placeholder="••••••••"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                />
              </label>
            </>
          )}

          <div className="flex justify-between items-center mt-6">
            <Button variant="primary" disabled={password !== password2}>
              Запази
            </Button>
          </div>

          {error && (
            <p className="text-red-700 text-sm my-2">
              Грешка:{' '}
              {error.message?.code === 11000
                ? 'Вече съществува акаунт с този email.'
                : error.code}
            </p>
          )}
        </form>
      </Container>
    </Page>
  );
}
